module.exports = __webpack_public_path__ + "static/img/松下大海豚系列.f779458a.png";